import Axios from 'axios'
import Vue from 'vue'
// import env from '@/env'
import { getUid } from '@/lib/role'
import { apiProxyUrl } from './_config'

import Message from 'element-ui/lib/message'

export const getCustomCookie = () => {
  let sessionId = localStorage.getItem('currentUserToken')
  if (sessionId === null || sessionId === undefined) return undefined

  let accessIp = localStorage.getItem('accessIp')
  let userId = getUid()
  return `sessionId=${sessionId};ip=${accessIp};userId=${userId}`
}

export const applyToken = token => {
  Vue.http.headers.common['customCookie'] = token
  Axios.defaults.headers.common['customCookie'] = token
}

export const requestHeaders = {
  'Content-Type': 'application/json',
  customCookie: getCustomCookie(),
}

export const transformRequest = (data = {}, headers) => {
  if (typeof data === 'string') return data

  return JSON.stringify(data)
}

export const responseInterceptor = response => response

export const exceptionInterceptor = error => {
  const status = error.response ? error.response.status : ''
  const dict = {
    404: '服务暂不可用',
    500: '服务内部错误',
  }

  Message.warning(dict[status] || '服务暂不可用')
  return Promise.reject(error)
}

export function createAxios(baseURL, options = {}, serviceName = '') {
  let _axios = Axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
    transformRequest: [transformRequest],
    timeout: 10000,
    ...options,
  })

  let _exceptionInterceptor = null
  if (serviceName) {
    _exceptionInterceptor = error => {
      const response = error.response
      let tip = '故障'
      let feedbackMethod = Message.warning
      if (!response) {
        tip = '没响应'
      } else {
        const status = response ? response.status : 0
        if (status === 404) {
          tip = '不在了'
        } else if (status === 500 && response.data.message) {
          tip = `[${status}] ${response.data.message}`
          feedbackMethod = Message.error
        } else {
          tip = `[${status}] 不给力`
        }
      }
      feedbackMethod('抱歉～ ' + serviceName + tip)
      return Promise.reject(error)
    }
  }
  _axios.interceptors.request.use(config => {
    config.headers = {
      ...config.headers,
      customCookie: getCustomCookie(),
    }
    return config
  })
  _axios.interceptors.response.use(
    responseInterceptor,
    _exceptionInterceptor || exceptionInterceptor
  )

  return _axios
}
export function getBaseURL(serviceDevHost, servicePort, serviceID) {
  return `${apiProxyUrl}/${serviceID}`
  // if (env === 'dev') {
  // }
  // if (env === 'dev' || env === 'test') {
  //   return 'http://ngwtest.sayyoo.cn/' + serviceID
  //   // return `http://${serviceDevHost}:${servicePort}/` + serviceID;
  // } else if (env === 'staging') {
  //   return 'http://typc.sayyoo.cn/' + serviceID
  // } else {
  //   return 'http://pcapi.sayyoo.cn/' + serviceID
  // }
}



// WEBPACK FOOTER //
// ./src/xhr/_utils.js